import {Button} from 'platform/components';
import {HStack, VStack} from 'platform/foundation';

import {mergeAll} from 'ramda';

import i18n from '@dms/i18n';
import {DmsDataGrid, refreshDmsDatagrid} from '@dms/shared';

import {Nullish, TestIdProps, suffixTestId} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

interface RequestsTabProps extends TestIdProps {
  directSaleItemId: string | Nullish;
}

export function RequestTabMaterialRequestsTab(props: RequestsTabProps) {
  const queryModifier = (filter: QueryFilterObject) =>
    mergeAll([
      filter,
      {
        originEntityId: props.directSaleItemId,
      },
    ]);

  return (
    <VStack spacing={0}>
      <DmsDataGrid
        gridCode="direct-sale-item-requests"
        queryModifier={queryModifier}
        autoHeight
        data-testid={suffixTestId('requests', props)}
      />
      <HStack justify="flex-end">
        <Button
          variant="link"
          title={i18n.t('general.actions.refresh')}
          leftIcon="navigation/refresh"
          onClick={() => refreshDmsDatagrid('direct-sale-item-requests')}
          data-testid={suffixTestId('requestsAction.refresh', props)}
        />
      </HStack>
    </VStack>
  );
}
